import React from "react";
import "./Services_main_page.css";
import { Outlet, NavLink } from "react-router-dom";

export default function Services() {
  return (
    <div className="services-page">
      {/* Hero Section */}
      <div className="services-hero">
        <div className="hero-overlay"></div>
        <h2>Our Services</h2>

        {/* Buttons */}
        <div className="hero-buttons">
          {/* ✅ INDEX LINK */}
          <NavLink
            to="."
            end
            className={({ isActive }) =>
              isActive ? "service-btn active" : "service-btn"
            }
          >
            Residential Projects
          </NavLink>

          <NavLink
            to="commercial-spaces"
            className={({ isActive }) =>
              isActive ? "service-btn active" : "service-btn"
            }
          >
            Commercial Spaces
          </NavLink>

          <NavLink
            to="property-consultation"
            className={({ isActive }) =>
              isActive ? "service-btn active" : "service-btn"
            }
          >
            Property Consultation
          </NavLink>
        </div>
      </div>

      {/* Content Section */}
      <div className="services-content">
        <Outlet />
      </div>
    </div>
  );
}
